import React from 'react';
import PropTypes from 'prop-types';
import Button from 'react-bootstrap/Button';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';
import Badge from 'react-bootstrap/Badge';

const excludedCountries = [
  "IN",
  "SG",
];

const buttonVariations = [
  {
    label: <>🎰 Win up to 5 BTC Daily</>,
    title: <>BC.Game: Top Crypto Game with BTC Dividends!</>,
    content: <>Enjoy 5000+ Games, 100+ Tokens, Win up to 5 BTC, Claim a 1080%
    Deposit Bonus and Play to Win $10,000 at a Trusted Global Crypto Casino
    with Premium Rewards!
    </>,
    href: "https://api.xrpscan.com/api/v1/campaign/bcgame1",
  },
]
let variantIndex = 0;
try {
  variantIndex = Math.floor((Math.random()*10)) % buttonVariations.length;
} catch (error) {}
const buttonVariation = buttonVariations[variantIndex];

const BCGameButton = (props) => {
  const { location } = props;
  if (!location || excludedCountries.includes(location)) {
    return <></>
  }

  const popover = (
    <Popover id="popover-sponsor">
      <Popover.Title>
        {buttonVariation.title}
        <span className="small ml-1"><Badge variant="secondary">SPONSORED</Badge></span>
      </Popover.Title>
      <Popover.Content>{buttonVariation.content}</Popover.Content>
    </Popover>
  );

  return (
    <span>
        <OverlayTrigger
          key={'bottom'}
          placement={'bottom'}
          overlay={popover}
        >
          <Button
            variant="info"
            size="sm"
            href={buttonVariation.href}
            target="_blank"
            rel="noopener nofollow"
            className="dropdown-toggle"
          >{buttonVariation.label}</Button>
        </OverlayTrigger>
    </span>
  )
}

BCGameButton.propTypes = {
  location: PropTypes.string.isRequired,
}

export default BCGameButton;